// Single source of truth for the app version.
// Frontend imports APP_VERSION from here.
// Backend reads this file at startup (see server.py: _read_app_version).
// To bump: change the string below — both frontend and /api/version follow.
export const APP_VERSION = "1.0.19";
